import { render } from "./centerOne.vue?vue&type=template&id=021f6b48&scoped=true"
import script from "./centerOne.vue?vue&type=script&lang=js"
export * from "./centerOne.vue?vue&type=script&lang=js"

import "./centerOne.vue?vue&type=style&index=0&id=021f6b48&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021f6b48"]])

export default __exports__